export const fillFields = (data: any, setValue: any) => {
    const keys = Object.keys(data)
    const values = Object.values(data)

    keys.forEach((key: string, index: number) => {
        setValue(key, values[index])
    })
}

export const resetFields = (data: any, setValue: any) => {
    data.forEach((key: string) => {
        setValue(key, '')
    })
}